import * as React from 'react'

import {Input} from '@/components/ui/input'
import {Button} from '@/components/ui/button'
import {Eye, EyeOff} from 'lucide-react'
import PropTypes from 'prop-types'

const PasswordInput = ({
    type = 'text',
    showValidCheck,
    onFocus,
    onBlur,
    'data-testid': dataTestId,
    ...props
}) => {
    const [show, setShow] = React.useState(false)
    return (
        <>
            <Input
                type={!show ? type : 'text'}
                showValidCheck={showValidCheck}
                onFocus={onFocus}
                onBlur={onBlur}
                data-testid={dataTestId || 'form-Input'}
                {...props}
            />
            {type === 'password' && (
                <Button
                    onClick={() => setShow((prev) => !prev)}
                    className="absolute right-[9px] top-[25px] transform -translate-y-1/2"
                    type="button"
                >
                    {show ? (
                        <EyeOff className="stroke-slate-700/70" size={18} />
                    ) : (
                        <Eye className="stroke-slate-700/70" size={18} />
                    )}
                </Button>
            )}
        </>
    )
}

PasswordInput.propTypes = {
    type: PropTypes.string,
    showValidCheck: PropTypes.bool,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    'data-testid': PropTypes.string
}

export {PasswordInput}
